import React, { Component } from 'react';

import { connect } from 'react-redux';
import config from 'config/api'
import withWidth from '@material-ui/core/withWidth';

import Spinner from 'components/Spinner';
import SectionIntro from './SectionIntro';
import SectionRecruitment from './SectionRecruitment';
import SectionRecruit from './SectionRecruit';
import SectionCompany from './SectionCompany';
import SectionDemo from './SectionDemo';
import SectionMore from './SectionMore';
import SectionUnits from './SectionUnits';
import SectionTeam from './SectionTeam';
import SectionEthic from './SectionEthic';
import SectionAbout from './SectionAbout';
import SectionContact from './SectionContact';

import { withRouter } from 'react-router-dom'

import {
  fetchData,
  getDataHome,
  getLoadingError,
} from '../../ducks/asyncFetcher';

const AF_KEY = 'home';

class Home extends Component {
  componentDidMount() {
    this.props.onMount();
  }

  componentDidUpdate(oldProps) {
    if (oldProps.$$data === undefined && this.props.$$data ) {
      if (this.props.location.hash !== '') {
        window.setTimeout(function() {
          const id = this.props.location.hash.replace('#', '');
          const el = document.getElementById(id);
          const top = el ? document.getElementById(id).offsetTop+10-document.getElementById('header').offsetHeight : false
          // console.log(id, el)
          window.scroll({
            top,
            // behavior: 'smooth'
          })
        }.bind(this), 50)
      }

    }
  }

  render() {
    const { $$data } = this.props;
    // const $$data = undefined;

    // console.log('DATA', $$data ? $$data.toJS() : false)
    // const { sectionProps } = this.props;
    const barOffset = ['xs'].indexOf(this.props.width) >= 0 ? 120 : 220;

    const horizontalOffset = ['xs'].indexOf(this.props.width) >= 0 ? 50 : 58

    const sectionProps = {
      barOffset,
      horizontalOffset
    }
    return (<div className="home">
    <Choose>
      <When condition={$$data !== undefined}>
        <SectionIntro width={this.props.width} style={{zIndex: 200}} {...sectionProps} $$data={$$data.get('units')}/>
        <SectionRecruitment width={this.props.width} style={{zIndex: 199}} $$data={$$data.get('recruitment')} {...sectionProps}/>
        <SectionRecruit width={this.props.width} $$data={$$data.get('candidat')} style={{zIndex: 198, marginTop: -10}} {...sectionProps}/>
        <SectionCompany width={this.props.width} style={{zIndex: 197, marginTop: -10}} $$data={$$data.get('entreprise')}  {...sectionProps}/>
        <SectionDemo width={this.props.width} style={{zIndex: 196, marginTop: -10}} {...sectionProps}/>
        <SectionUnits width={this.props.width} style={{zIndex: 195, marginTop: -10}} $$data={$$data.get('units')}  {...sectionProps}/>
        <SectionTeam width={this.props.width} style={{zIndex: 194, marginTop: -10}} $$data={$$data.get('equipe')} {...sectionProps}/>
        <SectionEthic width={this.props.width} $$data={$$data.get('ethique')} style={{zIndex: 193, marginTop: -10}} {...sectionProps}/>
        <SectionAbout width={this.props.width} style={{zIndex: 192, marginTop: -10}} $$data={$$data.get('lobster')}  {...sectionProps}/>
        <SectionMore width={this.props.width} style={{zIndex: 191, marginTop: -10}} $$data={$$data.get('more')} {...sectionProps}/>
        <SectionContact width={this.props.width} style={{zIndex: 190, marginTop: -10}} {...sectionProps}/>
      </When>
      <Otherwise>
        <div className={'Loading'}>
          <Spinner style={{marginTop: 200}}>Chargement...</Spinner>
        </div>
      </Otherwise>
    </Choose>

  </div>);
}
}

function mapStateToProps(state) {
  const props = {
    $$data: getDataHome(state),
    error: getLoadingError(state),
  };
  return props;
}
function mapDispatchToProps(dispatch) {
  return {
    onMount: () => {dispatch(fetchData( {key: AF_KEY, fetchUrl: config.home}))},
  };
}

// export default ;
export default withRouter(withWidth()(connect(mapStateToProps, mapDispatchToProps)(Home)));



// WEBPACK FOOTER //
// ./src/components/Home/Home.jsx